import { Icon } from "@blueprintjs/core"
import React from "react"
import StringInput from "components/Atoms/StringInput"
import DynamicSelector from "components/Molecules/DynamicSelector"
import LazyDynamicSelector from "components/Molecules/LazyDynamicSelector"
import LazyMultiSelector from "components/Molecules/LazyMultiSelector"
import {
  CERTIFICATES,
  COMMODITIES,
  SKUS,
  VARIETY_GROUPS,
} from "graphql/selector.queries.gql"

const CropDetails = () => (
  <div className="mt-2 mb-6">
    <div className="grid grid-cols-12 gap-4">
      <div className="col-span-3">
        <DynamicSelector
          required
          autoFocus={true}
          query={COMMODITIES}
          big={true}
          path={`commodity`}
          label="Commodity Name"
        >
          {/* <GroupRegistration></GroupRegistration> */}
        </DynamicSelector>
      </div>
      <div className="col-span-3">
        <StringInput
          required
          label="Crop Variety Name"
          big={true}
          path={`name`}
        ></StringInput>
      </div>
      <div className="col-span-3">
        <StringInput
          required
          label="Standard Deduction"
          path={`standardDeduction`}
          type="number"
          max={100}
          rightElement={<Icon icon="percentage"></Icon>}
          big={true}
        ></StringInput>
      </div>
    </div>
    <div className="grid grid-cols-12 gap-4 mt-3">
      <div className="col-span-3">
        <LazyDynamicSelector
          path="primaryGroup"
          query={VARIETY_GROUPS}
          label="Primary Group"
          big={true}
        />
      </div>
      <div className="col-span-3">
        <StringInput
          required
          big={true}
          label="Estimated Produce"
          helperText="Estimated Tonnage Per Acre"
          path={`estimatedProduce`}
          type="number"
        ></StringInput>
      </div>
      <div className="col-span-3">
        <DynamicSelector
          query={SKUS}
          big={true}
          label="Preferred SKU"
          helperText="useful when scheduling"
          path={`preferredSku`}
        />
      </div>
    </div>
    <div className="grid grid-cols-12 gap-4 mt-2">
      <div className="col-span-6">
        <LazyMultiSelector
          fill
          query={VARIETY_GROUPS}
          big={true}
          path="groups"
          label="Variety Groups"
        />
      </div>
      <div className="col-span-3">
        <DynamicSelector
          query={CERTIFICATES}
          big={true}
          label="Preferred Certificate Name"
          path={`preferredCertification`}
        />
      </div>
    </div>
  </div>
)

export default CropDetails
